import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AdminPage } from './pages/AdminPage';
import { ArchivePage } from './pages/ArchivePage';
import { CocktailMenuPage } from './pages/CocktailMenuPage';
import { ContactPage } from './pages/ContactPage';
import { EducationConsultingPage } from './pages/EducationConsultingPage';
import { GuidelinePage } from './pages/GuidelinePage';
import { HomePage } from './pages/HomePage';
import { NightCommunityPage } from './pages/NightCommunityPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { QrPage } from './pages/QrPage';
import { QMenuPage } from './pages/QMenuPage';
import { QReservePage } from './pages/QReservePage';
import { QVisitPage } from './pages/QVisitPage';
import { ReservePage } from './pages/ReservePage';
import { SecretOrderPage } from './pages/SecretOrderPage';
import { ShopPage } from './pages/ShopPage';
import { TabletMenuPage } from './pages/TabletMenuPage';
import { TarotConsultationPage } from './pages/TarotConsultationPage';
import { VisitPage } from './pages/VisitPage';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { StickyReserveCta } from './components/StickyReserveCta';

// QR/태블릿/관리자 화면은 사이트 크롬(헤더/푸터/CTA) 없이 렌더링한다.
const COMPACT_ROUTES = ['/tablet', '/qr', '/secretorder', '/q-menu', '/q-reserve', '/q-visit', '/admin'];

// 구버전 경로 → 새 구조 리다이렉트
const LEGACY_REDIRECTS: Record<string, string> = {
  '/tarot': '/tarot-consultation',
  '/experience': '/tarot-consultation',
  '/menu': '/cocktail-menu',
  '/community': '/night-community',
  '/arcademy': '/education-consulting',
  '/about': '/'
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function App() {
  const location = useLocation();
  const compact = COMPACT_ROUTES.includes(location.pathname);

  return (
    <div className={compact ? 'app-shell' : 'app-shell tm-body'}>
      <ScrollToTop />
      {!compact && <SiteHeader />}
      <main className={compact ? 'page-wrap tablet-full' : undefined}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tarot-consultation" element={<TarotConsultationPage />} />
          <Route path="/cocktail-menu" element={<CocktailMenuPage />} />
          <Route path="/night-community" element={<NightCommunityPage />} />
          <Route path="/education-consulting" element={<EducationConsultingPage />} />
          <Route path="/archive" element={<ArchivePage />} />
          <Route path="/visit" element={<VisitPage />} />
          <Route path="/reserve" element={<ReservePage />} />
          {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
            <Route path={from} element={<Navigate to={to} replace />} key={from} />
          ))}
          <Route path="/guideline" element={<GuidelinePage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/tablet" element={<TabletMenuPage />} />
          <Route path="/qr" element={<QrPage />} />
          <Route path="/q-menu" element={<QMenuPage />} />
          <Route path="/q-reserve" element={<QReservePage />} />
          <Route path="/q-visit" element={<QVisitPage />} />
          <Route path="/secretorder" element={<SecretOrderPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      {!compact && <SiteFooter />}
      {!compact && <StickyReserveCta />}
    </div>
  );
}
